import { ReactNode } from 'react'

import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { BooleanField, formatDate } from '@avantstay/backoffice-core'

import { PermittingInfoProps } from '@arriere/types/Properties.types'

export const formatDateField = (value?: IDate) => {
  return value ? formatDate(value, 'MM/dd/yyyy') : value
}

export const formatDateTimeField = (value?: IDate) => {
  return value ? formatDate(value, 'MM/dd/yyyy HH:mm:ss') : value
}

export const formatBooleanField = (field: string, value?: boolean) => {
  return <BooleanField id={field} mode="read" onChange={() => null} value={!!value} />
}

export const parseFieldValue = ({
  value,
  format,
}: {
  value?: PermittingInfoProps[keyof PermittingInfoProps]
  format?: (value?: any) => ReactNode
}): ReactNode => {
  const fallbackValue = '-'

  try {
    if (value === undefined || value === null) return fallbackValue

    if (format) return format(value) ?? fallbackValue

    const sanitizedValue = String(value).replace(/\\r\\n|\\n/g, '\n')
    return sanitizedValue
  } catch {
    return fallbackValue
  }
}
